import React from 'react'
import { css } from 'styled-system/css'
import { Roundel } from '@mindfulchefuk/design-system/Roundel/Roundel'
import { Icon, Text } from '@mindfulchefuk/design-system'
import { flex } from 'styled-system/patterns'

type TOnboardingCartDrawerRecipeActions = {
  addItem: () => void
  isAbleToAddRecipes: boolean
  quantity: number
  recipeTitle: string
  removeItem: () => void
}

const buttonStyles = css({
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  _disabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
  },
})

export const OnboardingCartDrawerRecipeActionButtons = ({
  addItem,
  isAbleToAddRecipes,
  quantity,
  recipeTitle,
  removeItem,
}: TOnboardingCartDrawerRecipeActions) => {
  const removalArialLabelCopy =
    quantity === 1
      ? `Remove ${recipeTitle} from your basket`
      : `Remove one ${recipeTitle} from your basket`

  return (
    <div
      className={flex({
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 24,
      })}
    >
      <button
        aria-label={removalArialLabelCopy}
        className={buttonStyles}
        data-testid="decrement-button"
        onClick={removeItem}
        type="button"
      >
        <Roundel filled size={28}>
          <Icon type="minus" size={12} />
        </Roundel>
      </button>
      <Text
        color="aubergine"
        variant="body-lg-500"
        data-testid="recipe-quantity"
      >
        {quantity}
      </Text>
      <button
        aria-label={`Add another ${recipeTitle} to your basket`}
        className={buttonStyles}
        data-testid="increment-button"
        disabled={!isAbleToAddRecipes}
        onClick={addItem}
        type="button"
      >
        <Roundel filled size={28}>
          <Icon type="plus" size={12} />
        </Roundel>
      </button>
    </div>
  )
}
